export const COLORS = {
  primaryColor: '#4EA6DC',
  secondaryColor: '#E32D91',
  white: '#fff',
  black: '#000',
  mainBackgroundColor: '#272E41',
};
